import { render, staticRenderFns } from "./PageManagePost.vue?vue&type=template&id=43abc303&scoped=true&"
import script from "./PageManagePost.vue?vue&type=script&lang=js&"
export * from "./PageManagePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43abc303",
  null
  
)

export default component.exports